import { AfterViewInit, Directive, ElementRef, Input, NgZone, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appFillHeight]'
})
export class FillHeightDirective implements AfterViewInit, OnDestroy {
  @Input() bottomPadding = 16;

  private resizeObserver!: ResizeObserver;
  private readonly onWindowResize = () => this.updateHeight();

  constructor(
    private readonly el: ElementRef<HTMLElement>,
    private readonly ngZone: NgZone
  ) {}

  ngAfterViewInit(): void {
    // Defer one tick so the DOM has fully rendered before measuring
    Promise.resolve().then(() => this.updateHeight());

    this.ngZone.runOutsideAngular(() => {
      this.resizeObserver = new ResizeObserver(() => this.updateHeight());

      // Watch all preceding siblings (filter bar, search bar, etc.)
      // When they wrap to more rows their height changes — we recalculate.
      let sibling = this.el.nativeElement.previousElementSibling;
      while (sibling) {
        this.resizeObserver.observe(sibling);
        sibling = sibling.previousElementSibling;
      }

      window.addEventListener('resize', this.onWindowResize, { passive: true });
    });
  }

  private updateHeight(): void {
    const el = this.el.nativeElement;
    const top = el.getBoundingClientRect().top;
    // Use visualViewport when available — accounts for mobile browser chrome (address bar)
    const viewportHeight = window.visualViewport?.height ?? window.innerHeight;
    const height = viewportHeight - top - this.bottomPadding;
    el.style.height = `${Math.max(height, 100)}px`;
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.onWindowResize);
  }
}
